export const PACKAGE_VERSION = '0.30.0';
//# sourceMappingURL=package-version.js.map